import CryptoJS from 'crypto-js';
/**
 * Decrypts an AES-128 encrypted text using CBC mode and PKCS5 padding.
 *
 * @param {string} encryptedText - Base64 encrypted string
 * @param {string} secretKey - Secret key used for encryption (must be 16 bytes for AES-128)
 * @param {string} iv - Initialization Vector used during encryption (must be 16 bytes)
 * @returns {string} - Decrypted plain-text
 */
const decryptAES_CBC = (encryptedText, secretKey, iv) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const ivWordArray = CryptoJS.enc.Utf8.parse(iv);
const cipherParams = CryptoJS.enc.Base64.parse(encryptedText);
     const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: cipherParams },
      key,
      {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    const plainText = decrypted.toString(CryptoJS.enc.Utf8);
    return plainText;
  } catch (error) {
    console.error('Decryption failed:', error);
    return 'Decryption Error';
  }
};

const asePasskey ="7f989e7193e65e5cea51876264c47248";
const encryptData = async function (plainText) {
  try {
    const ciphertext = CryptoJS.AES.encrypt(plainText, asePasskey).toString();
    return ciphertext;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export { encryptData };

export default decryptAES_CBC;